import { FreeConditionModel, PromotionProductModel } from "states/promotion-model-shared";

export interface PromotionCodeModel {
  type: PromotionValueType;
  discountValue: number;
  numberOfGifts: number;
  gifts: PromotionProductModel[];
  freeConditions: FreeConditionModel[];
}
export interface PromotionCodeRequestModel{
  code: string;
  applyPromotionRequest: ApplyPromotionRequestModel;
}
export interface ApplyPromotionRequestModel{
  branchId: number;
  subTotalAmount: number;
  products: PromotionProductRequestModel[];
}
export interface PromotionProductRequestModel{
  id: number;
  quantity: number;
}
export interface PromotionValueGiftModel {
  products: PromotionValueGiftProductModel[];
  numberOfGifts: number;
}
export interface PromotionValueGiftProductModel {
  id: number;
  name: string;
  image: string;
}
export enum PromotionValueType {
  Discount,
  Gift,
}
